// based on http://stackoverflow.com/a/22365674/462087

module.exports = {
  key: "config options just for UI",
  catalogo_url: "http://192.168.1.67:3010",
  google_maps_api: "https://maps.googleapis.com/maps/api/js?key=AIzaSyC2hJdHmMJd5wNCBRPTjXY1j3oDgyPUteQ&v=3.exp&libraries=geometry,drawing,places",
  tripmaker_payment_link: (tripId, paymentKey) => `https://tripmaker.es/payment?_id=${tripId}&paymentkey=${paymentKey}`,
  reset_zsx_url: "https://www.zhangshangxby.com/updatecontent/naslkn1onl9oap1gjqx",
}
